__turbopack_context__.v({
  "errorSummaryText": "signIn-module-scss-module__KUfNtq__errorSummaryText",
  "innerFormWrapper": "signIn-module-scss-module__KUfNtq__innerFormWrapper",
  "inputFieldsWrapper": "signIn-module-scss-module__KUfNtq__inputFieldsWrapper",
  "legalTextStyles": "signIn-module-scss-module__KUfNtq__legalTextStyles",
  "linkStyles": "signIn-module-scss-module__KUfNtq__linkStyles",
  "linkStylesLeft": "signIn-module-scss-module__KUfNtq__linkStylesLeft",
  "notificationMessageEnter": "signIn-module-scss-module__KUfNtq__notificationMessageEnter",
  "notificationMessageExit": "signIn-module-scss-module__KUfNtq__notificationMessageExit",
  "notificationMessageWrapper": "signIn-module-scss-module__KUfNtq__notificationMessageWrapper",
  "radioButtonHelperText": "signIn-module-scss-module__KUfNtq__radioButtonHelperText",
  "radioButtonLabel": "signIn-module-scss-module__KUfNtq__radioButtonLabel",
  "registerLinkWrapper": "signIn-module-scss-module__KUfNtq__registerLinkWrapper",
  "signInBody": "signIn-module-scss-module__KUfNtq__signInBody",
  "streamingHeaderSection": "signIn-module-scss-module__KUfNtq__streamingHeaderSection",
  "teslaOptionsScreenStyles": "signIn-module-scss-module__KUfNtq__teslaOptionsScreenStyles",
  "verificationCodeHeaderWrapper": "signIn-module-scss-module__KUfNtq__verificationCodeHeaderWrapper",
});
